import * as ng from 'angular';

export class AtomTextShowAllController implements ng.IController {
    public static $inject: string[] = [];

    public modifier: string;

    $onInit() {
        this.modifier = this.modifier || '';
    }
}

export class AtomTextShowAllComponent implements ng.IComponentOptions {
    public bindings = {
        modifier: '@?'
    };
    public controller =  AtomTextShowAllController;
    public template = require('./text-show-all.html');
}
